import { ApiRequestModel } from "../api_request_model";
import { BaseClass, RoleFeatureLinkInfoController} from "../master/mastermodel";
import { xLoginResponse } from "./loginresponsemodel";
import { AppData } from '../appdata';
const isNullOrUndefined = (val: any) => val === null || val === undefined;

export class LoginRequest {
  public UserName: string;
  public Password: string;
  public RequestMode: string;
  public RequestType: number;
  public IsEncriptFromClient: boolean;
  public ClientDate: Date;
}

export class IsSessionExistsRequest extends BaseClass {
 // public SendApiRequestModel: ApiRequestModel;
}


//export class FacilityConfigParamRequest extends BaseClass {
//  public FacilityCode: string;
//}
export class AppUserSettingRequest extends BaseClass {
  public FacilityCode: number;
  public ActorCode: number;
  public UserType: number;
}
export class FacilityConfigParamController {
  public FacilityConfigParamCode: number;
  public FacilityCode: number;
  public ConfigParam: string;
  public ConfigParamType: string;
  public ConfigParamValue: string;
}
export class AppUserSettingInfoController {
  //public FacilityConfigParamController: Array<FacilityConfigParamController>;

  public FacilityConfigParamController: FacilityConfigParamController[];
  public RoleFeatureLinkInfoController: RoleFeatureLinkInfoController[];
    public xLoginController: xLoginResponse;


    //HasAccess(featureName: string): boolean {

    //    if (!isNullOrUndefined(this.RoleFeatureLinkInfoController)) {
    //        var f = this.RoleFeatureLinkInfoController.filter(function (v, i, d) {
    //            return v.FeatureName == featureName && AppData.Instance().SelectedRoleName == v.RoleName;
    //        });
    //    }

    //    return (!isNullOrUndefined(AppData.Instance()) && AppData.Instance().SelectedRoleName == 'Super Admin') ||
    //        (f != null && f.length > 0);
    //}
    //HasAccess2(featureName: string): boolean {

    
      
    //    var f = this.RoleFeatureLinkInfoController.filter(function (v, i, d) {
    //        return v.FeatureName == featureName && AppData.Instance().SelectedRoleName == v.RoleName;
    //    });
    //    return false;
    //}

  
}

